/*******************************************************************************
UPDATE DATA BASED ON CHECKBOX FILTER STATUS
Handles a change to a checkbox filter.
*******************************************************************************/

import filterItems from './filter-items';
import getFilterSettings from './get-settings';

export default function updateCheckboxFilter(checkboxName) {

    // Get the settings for the filter
    const settings = getFilterSettings(checkboxName);

    // Filter the items using the checkbox's settings
    filterItems(settings);
}
